<template>
  <section class="group-order-details">
    <div class="group-order-details-wrapper">
      <GroupOrderTierHeader
        :title="`General`"
        :disabled="true"
        customStyles="border-radius: 12px; padding-left: 3rem"
        :isGroupOrderTier="false"
      />

      <section class="general-section">
        <div class="head-content">
          <p>Date created</p>
          <span>{{ defaultFormatAndParse(groupOrderDetails.createdAt) }}</span>

          <p>Page ID</p>
          <span>{{ groupOrderDetails.uuid | splitUID }}</span>

          <p>Creator</p>
          <span>{{ groupOrderDetails.createdByUser.email }}</span>

          <p>Submissions</p>
          <span>{{ groupOrderDetails.submissionsCount }}</span>

          <p>Status</p>
          <span>{{ currentState }}</span>

          <p v-if="groupOrderDetails.state !== 'finalized'" class="pill-holder">
            Lock page
            <!-- <span>
              <ToolTipInfo
                popOverPosition="right"
                popOverContent="When turned on, inbound order submissions will no longer be accepted.;Turning off <strong>Lock</strong> will continue accepting submissions."
              />
            </span> -->
          </p>
          <div v-if="groupOrderDetails.state !== 'finalized'">
            <div class="toggle-info">
              <label class="toggle-button" :class="{ disabled: disabled }">
                <input
                  type="checkbox"
                  :checked="isLockOrUnlock"
                  @click.prevent="
                    toggleGroupOrderStatus(
                      groupOrderDetails.state === 'pending' ? 'lock' : 'unlock'
                    )
                  "
                />
                <span class="toggle-slider round"></span>
              </label>
              <small class="lock-status">{{
                isLockOrUnlock
                  ? 'Not accepting submissions'
                  : 'Accepting submissions'
              }}</small>
            </div>
          </div>

          <p v-if="groupOrderDetails.state !== 'finalized'" class="pill-holder">
            Show prices
            <span>
              <ToolTipInfo
                popOverPosition="left"
                popOverContent="Display product prices on redemption page."
                popoverWrapperClass="relative md:-left-24"
              />
            </span>
          </p>
          <div v-if="groupOrderDetails.state !== 'finalized'">
            <div class="toggle-info">
              <label class="toggle-button">
                <input
                  type="checkbox"
                  name="toggle-prices"
                  :checked="groupOrderDetails.showPrices"
                  @click="setShowPrice()"
                />
                <span class="toggle-slider round"></span>
              </label>
            </div>
          </div>

          <p v-if="groupOrderDetails.state !== 'finalized'" class="pill-holder">
            Auto-Finalize

            <span>
              <ToolTipInfo
                popOverPosition="left"
                :popOverContent="autoFinalizeTooltipContent"
                popoverWrapperClass="relative md:-left-24"
              />
            </span>
          </p>
          <div v-if="groupOrderDetails.state !== 'finalized'">
            <div class="toggle-info">
              <label
                :title="orderAutoFinalizing ? 'Updating... please wait' : ''"
                class="toggle-button"
                :class="{ 'toggle-disabled': orderAutoFinalizing }"
              >
                <input
                  :disabled="orderAutoFinalizing"
                  type="checkbox"
                  :checked="instantFinalizeState"
                  @click.prevent="showAutofinalizeModal"
                />
                <span class="toggle-slider round cursor-not-allowed"></span>
              </label>
            </div>
          </div>
          <p
            v-if="groupOrderDetails.state !== 'finalized'"
            class="pill-holder"
          />
          <p
            v-if="groupOrderDetails.state !== 'finalized'"
            class="pill-holder"
          />
          <p class="pill-holder">
            Email verification
          </p>
          <div class="toggle-info">
            <label class="toggle-button">
              <input
                type="checkbox"
                :checked="isEmailVerified"
                @click="setEmailVerification"
              />
              <span class="toggle-slider round cursor-not-allowed"></span>
            </label>
          </div>
        </div>
      </section>

      <div class="head-content-mobile">
        <div class="head-content-mobile-container">
          <p>Date</p>
          <span>{{ defaultFormatAndParse(groupOrderDetails.createdAt) }}</span>
        </div>
        <div class="head-content-mobile-container">
          <p>Status</p>
          <span>{{ currentState }}</span>
        </div>
        <div class="head-content-mobile-container">
          <p>Page ID</p>
          <span>{{ groupOrderDetails.uuid | splitUID }}</span>
        </div>
        <div class="head-content-mobile-container">
          <p v-if="groupOrderDetails.state !== 'finalized'" class="pill-holder">
            Lock
            <span>
              <ToolTipInfo
                popOverPosition="left"
                popOverContent="When turned on, inbound order submissions will no longer be accepted.;Turning off <strong>Lock</strong> will continue accepting submissions."
                popoverWrapperClass="relative md:-left-24"
              />
            </span>
          </p>
          <div v-if="groupOrderDetails.state !== 'finalized'">
            <div class="toggle-info">
              <label class="toggle-button" :class="{ disabled: disabled }">
                <input
                  type="checkbox"
                  :checked="isLockOrUnlock"
                  @click.prevent="
                    toggleGroupOrderStatus(
                      $event,
                      groupOrderDetails.state === 'pending' ? 'lock' : 'unlock'
                    )
                  "
                />
                <span class="toggle-slider round"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="head-content-mobile-container">
          <p>Creator</p>
          <span>{{ groupOrderDetails.createdByUser.email }}</span>
        </div>
        <div class="head-content-mobile-container">
          <p v-if="groupOrderDetails.state !== 'finalized'" class="pill-holder">
            Show prices
            <span>
              <ToolTipInfo
                popOverPosition="left"
                popOverContent="When turned on, product prices are shown to recipents."
                popoverWrapperClass="relative md:-left-24"
              />
            </span>
          </p>
          <div v-if="groupOrderDetails.state !== 'finalized'">
            <div class="toggle-info">
              <label class="toggle-button">
                <input
                  type="checkbox"
                  name="toggle-prices"
                  :checked="groupOrderDetails.showPrices"
                  @click="setShowPrice()"
                />
                <span class="toggle-slider round"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="head-content-mobile-container">
          <p>Submissions</p>
          <span>{{ groupOrderDetails.submissionsCount }}</span>
        </div>
        <div class="head-content-mobile-container">
          <p v-if="groupOrderDetails.state !== 'finalized'" class="pill-holder">
            Auto-Finalize

            <span>
              <ToolTipInfo
                popOverPosition="left"
                popOverContent="When turned on, orders are created instantly as submissions are recieved. Any further action on orders cannot be taken."
                popoverWrapperClass="relative md:-left-24"
              />
            </span>
          </p>
          <div
            class="pill-holder"
            v-if="groupOrderDetails.state !== 'finalized'"
          >
            <div class="toggle-info">
              <label
                :title="orderAutoFinalizing ? 'Updating... please wait' : ''"
                class="toggle-button"
                :class="{ 'toggle-disabled': orderAutoFinalizing }"
              >
                <input
                  :disabled="orderAutoFinalizing"
                  type="checkbox"
                  :checked="instantFinalizeState"
                  @click.prevent="showAutofinalizeModal"
                />
                <span class="toggle-slider round cursor-not-allowed"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="head-content-mobile-container">
          <p class="pill-holder">
            Email Verification
          </p>
          <div class="toggle-info">
            <label class="toggle-button">
              <input
                type="checkbox"
                :checked="isEmailVerified"
                @click="setEmailVerification"
              />
              <span class="toggle-slider round cursor-not-allowed"></span>
            </label>
          </div>
        </div>
      </div>
      <!-- Background Photo here -->
      <div class="background-content-holder">
        <div class="background-content">
          <div>
            <p class="modified background">
              Cover photo

              <span>
                <ToolTipInfo
                  :popOverContent="backgroundTooltip"
                  :popOverPosition="tooltipPosition"
                  icon="i"
                  popoverWrapperClass="relative md:-left-24"
                />
              </span>
            </p>
          </div>

          <div class="banner-section">
            <div class="banner-portrait">
              <img :src="backgroundImage" />
            </div>
            <label for="banner-upload" class="custom-file-upload">
              Upload <span> <img src="../../assets/upload.svg" alt="" /> </span>
            </label>
            <input
              id="banner-upload"
              type="file"
              @change="handleUpload($event)"
            />

            <ImageCropper
              :image="image"
              :aspect-ratio="9 / 16"
              :isOpen="isCropTool"
              @closeModal="isCropTool = false"
              @crop="handleCroppedData"
            />
          </div>
        </div>
      </div>

      <!-- Size Chart here -->
      <div class="background-content-holder">
        <div class="background-content">
          <p class="modified">Size Chart</p>

          <div v-if="!sizeChartImage || isReplacingSizeChart">
            <FileUpload
              :loading="uploadLoading"
              :timeoutDuration="2000"
              @fileChange="
                e =>
                  uploadBackground(
                    e,
                    'group_order[group_order_attachment][file]',
                    false
                  )
              "
              id="size-chart"
              :isTransparent="true"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .pdf, .png, .jpg, .jpeg"
            />
          </div>

          <!-- File holder here -->
          <div
            v-if="sizeChartImage && !isReplacingSizeChart"
            class="file-holder"
          >
            <p @click="openSizeChart" class="file-name">{{ sizeChartImage }}</p>

            <div class="flex items-center justify-start">
              <label for="size-chart" class="custom-file-upload">
                Replace file
              </label>

              <input
                v-if="groupOrderDetails.state !== 'finalized'"
                id="size-chart"
                type="file"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .pdf, .png, .jpg, .jpeg"
                @change="
                  uploadBackground(
                    $event,
                    'group_order[group_order_attachment][file]',
                    true
                  )
                "
              />

              <p class="allowed-files">
                Files supported: JPG, PNG, PDF, CSV
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="custom-section-holder">
        <GroupOrderTierHeader
          :title="`Custom`"
          :disabled="true"
          customStyles="border-radius: 12px; padding-left: 3rem"
          :isGroupOrderTier="false"
        />
      </div>

      <!-- Customizables Here -->
      <div class="background-content-holder margin-top-2">
        <section>
          <!-- Title Region Here -->
          <div class="info-holder-sub-header">Cover Page</div>
          <div class="region-holder">
            <div class="title">
              <p class="text-left"><strong>Heading </strong></p>
              <small>Select a heading for your redemption page landing.</small>
            </div>

            <!-- Default Title Here -->
            <div class="customizables">
              <div class="radio-holder">
                <radio-button
                  label="Default"
                  value="default-title"
                  v-model="redemptionTitle"
                  :isGroupOrder="true"
                  :isTransparent="true"
                  @change="updateGroupOrder($event, 'defaultTitle')"
                  custom-styles="font-size: 0.813rem"
                />
              </div>

              <div class="caption">
                <p>
                  Welcome to {{ groupOrderDetails.name }} for
                  {{ groupOrderDetails.teamName }}!
                </p>
              </div>
            </div>

            <!-- Custom Title Here -->
            <div class="customizables">
              <div class="radio-holder">
                <radio-button
                  label="Custom"
                  value="custom-title"
                  v-model="redemptionTitle"
                  :isGroupOrder="true"
                  :isTransparent="true"
                  @change="handleCustomChange($event, 'customTitle')"
                  custom-styles="font-size: 0.813rem"
                />
              </div>

              <!-- <div class="caption"> -->
              <textarea
                id="title-textarea"
                :disabled="redemptionTitle !== 'custom-title'"
                rows="1"
                placeholder="Add title"
                v-model="customTitle"
                @keyup="handleKeyUp"
                @blur="handleBlur('title')"
              ></textarea>
              <small class="characters-info"> </small>
              <small class="characters-info">
                {{
                  `${customTitleCharactersLeft} ${
                    customTitleCharactersLeft > 1 ? 'words' : 'word'
                  }  left`
                }}
              </small>
              <!-- </div> -->
            </div>
          </div>

          <!-- Description Region Here -->
          <div class="region-holder">
            <div class="title">
              <p class="text-left"><strong>Description </strong></p>
              <small
                >Select a description for your redemption page landing.</small
              >
            </div>

            <!-- Default Description Here -->
            <div class="customizables">
              <div class="radio-holder">
                <radio-button
                  label="Default"
                  value="default-description"
                  :isGroupOrder="true"
                  :isTransparent="true"
                  v-model="redemptionDescription"
                  @change="updateGroupOrder($event, 'defaultDescription')"
                  custom-styles="font-size: 0.813rem"
                />
              </div>

              <div class="caption">
                <p>
                  You've been invited by {{ groupOrderDetails.teamName }} to
                  submit your information to receive a special gift or swag.
                  Thank you for being a valued partner.
                </p>
              </div>
            </div>

            <!-- Custom Description Here -->
            <div class="customizables">
              <div class="radio-holder">
                <radio-button
                  label="Custom"
                  value="custom-description"
                  v-model="redemptionDescription"
                  :isTransparent="true"
                  :isGroupOrder="true"
                  @change="handleCustomChange($event, 'customDescription')"
                  custom-styles="font-size: 0.813rem"
                />
              </div>

              <textarea
                :class="{
                  custom: redemptionDescription == 'custom-description'
                }"
                :disabled="redemptionDescription !== 'custom-description'"
                :rows="redemptionDescription == 'custom-description' ? 3 : 1"
                placeholder="Add description*"
                v-model="customDescription"
                @keyup="handleKeyUp"
                @blur="handleBlur('description')"
              ></textarea>
              <small class="characters-info"> </small>
              <small class="characters-info">
                {{
                  `${customDescriptionCharactersLeft} ${
                    customDescriptionCharactersLeft > 1 ? 'words' : 'word'
                  }  left`
                }}
              </small>
            </div>
          </div>
        </section>
      </div>
      <div class="custom-section-holder">
        &nbsp;
      </div>
      <!-- Customizables Here -->
      <div class="background-content-holder margin-top-1">
        <section>
          <!-- Title Region Here -->
          <div class="info-holder-sub-header">Product Selection(s)</div>
          <div class="region-holder">
            <div class="title">
              <p class="text-left"><strong>Additional instructions </strong></p>
              <small
                >Add any additional instructions or recommendations to users for
                selecting products. This text will be displayed on the products
                page banner along with the default instructions.</small
              >
            </div>
          </div>
          <div class="detail">
            <div class="customize-section">
              <div class="input-holder special-instruction-holder">
                <textarea
                  id="title-textarea"
                  rows="1"
                  placeholder="Type instructions"
                  v-model="customSubTitle"
                  @keyup="handleKeyUp"
                  @paste="handleKeyUp"
                  @blur="handleBlur('sub-title')"
                ></textarea>
                <small class="characters-info">
                  {{
                    `${customSubtitleCharactersLeft} ${
                      customSubtitleCharactersLeft > 1 ? 'words' : 'word'
                    }  left`
                  }}
                </small>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="custom-section-holder">
        <GroupOrderTierHeader
          :title="`Page Access`"
          :disabled="true"
          customStyles="border-radius: 12px; padding-left: 3rem"
          :isGroupOrderTier="false"
        />
      </div>
      <!-- Customizables Here -->
      <div class="background-content-holder margin-top-1">
        <section>
          <!-- Title Region Here -->
          <div class="region-holder">
            <div class="title">
              <p class="text-left  margin-top-1">
                <strong>Sign-in method </strong>
              </p>
              <small
                >Select how users can sign in to your redemption page.</small
              >
            </div>
          </div>

          <!-- Allowed List Here -->
          <div class="background-content login-methods">
            <GroupOrderLoginMethods
              @onUpdateDomains="handleUpdateDomains"
              :allowed_domains="groupOrderDetails.allowedDomains"
              :isProjects="false"
            />
          </div>
        </section>
      </div>
      <!-- Modals Here -->
      <section>
        <AutofinalizeModal
          :showFooter="true"
          modalName="autofinalize"
          colorVariation="coast"
          v-if="showConfirmModal"
          @confirmAction="cofirmAutoFinalize($event)"
        >
          <template slot="header">
            <h4 class="header">You are about to auto-finalize submissions</h4>
          </template>
          <template slot="body">
            <p class="confirm-text">
              {{
                `Please confirm you would like to send all orders as they're submitted in this Redemption Page. \n
            Turning on Auto-Finalize will instantly create new orders as we receive submissions. You will not be able to
            review, edit or cancel orders once this feature has been enabled.`
              }}
            </p>
          </template>
        </AutofinalizeModal>
      </section>
    </div>
    <section class="flex md:w-1/3 gap-4 justify-end projects-footer-actions">
      <button
        @click="handleCancel"
        class="button-gemnote button-gemnote--small custom-button w-full"
      >
        <span>Cancel</span>
      </button>
      <button
        @click="handleSaveChanges"
        class="button-gemnote button-gemnote--small  w-full"
      >
        <span>Save Changes</span>
      </button>
    </section>
  </section>
</template>

<script>
import DateFns from '@/mixins/DateFns'
import { mapState } from 'vuex'
import { defaultNotFoundImage } from '../../helpers'
import ToolTipInfo from '../Universal/ToolTipInfo.vue'
import RadioButton from '../Universal/RadioButton.vue'
import { debounce } from 'lodash'
import FileUpload from '@/components/Universal/FileUpload'
import ImageCropper from '@/components/Universal/ImageCropper'
import GroupOrderLoginMethods from '@/components/GroupOrder/LoginMethods'
import GroupOrderTierHeader from '@/components/GroupOrder/GroupOrderTierHeader'

let bodyFormData = new FormData()

export default {
  name: 'GroupOrderSettingsTab',
  mixins: [DateFns],

  components: {
    AutofinalizeModal: () => import('@/components/Universal/ConfirmModal'),
    ToolTipInfo,
    RadioButton,
    FileUpload,
    ImageCropper,
    GroupOrderLoginMethods,
    GroupOrderTierHeader
  },

  props: {
    groupOrderDetails: {
      type: Object,
      required: true,
      default: function() {
        return {}
      }
    }
  },

  data() {
    return {
      image: null,
      isCropTool: false,
      isVisible: false,
      updatingDomain: false,
      isEditingPassword: false,
      customDescription: '',
      customTitle: '',
      customSubTitle: '',
      password: '',
      passwordValue: 'no-password',
      redemptionDescription: 'default-description',
      redemptionTitle: 'default-title',
      redemptionSubTitle: 'default-subtitle',
      allowed_domains: [],
      selectedLists: [],
      isEmailVerified: false,
      finalizeRedemptionModalName: 'finalizeRedemptionPageModal',
      customTitleMaxCharacters: 10,
      customDescriptionMaxCharacters: 100,
      customSubTitleMaxCharacters: 20,
      uploadLoading: false,
      isReplacingSizeChart: false
    }
  },

  mounted() {
    this.updateData()
    this.allowed_domains = this.groupOrderDetails.allowedDomains
    this.$store.dispatch('recipient/loadRecipientList')
    this.$store.dispatch('groupOrder/loadAllowList', this.groupOrderDetails.id)
  },

  computed: {
    isTeamOwner() {
      return (
        this.user && this.user.roles && this.user.roles.includes('team_owner')
      )
    },
    ...mapState({
      updatingGroupOrderPassword: state =>
        state.groupOrder.updatingGroupOrderPassword,
      showConfirmModal: state => state.modal.showConfirmModal,
      team: state => state.team.team,
      recipientList: state => state.recipient.recipientListRecords,
      selectedRecipient: state => state.recipient.selectedRecipientList,
      removeAllUsers: state => state.groupOrder.removeAllUsers,
      updatingAutoFinalizing: state => state.groupOrder.updatingAutoFinalizing,
      user: state => state.profile.user,
      finalizingGroupOrder: state => state.groupOrder.finalizingGroupOrder
    }),
    orderAutoFinalizing() {
      if (this.groupOrderDetails.state === 'lock_finalisation') {
        return false
      } else {
        return this.$store.getters['groupOrder/orderAutoFinalizing']
      }
    },
    backgroundTooltip() {
      return `Maximum file size supported: 5MB. \n
For best results, we recommend uploading image with Aspect Ratio 16:9.`
    },
    autoFinalizeTooltipContent() {
      return `Orders are created instantly as submissions are received.   \n
      
              No further action on orders can be taken if enabled.`
    },

    tooltipPosition() {
      if (this.innerWidth < 1000) {
        return 'bottom-start'
      }
      return 'left'
    },

    disabled() {
      switch (this.groupOrderDetails.state) {
        case 'pending':
          return false
        case 'locked':
          return false
        case 'finalized':
          return true
        case 'auto_finalising':
          return false
        default:
          return false
      }
    },
    isLockOrUnlock() {
      switch (this.groupOrderDetails.state) {
        case 'pending':
          return false
        case 'locked':
          return true
        case 'finalized':
          return true
        case 'auto_finalising':
          return false
        default:
          return false
      }
    },
    currentState() {
      switch (this.groupOrderDetails.state) {
        case 'locked':
          return 'Locked'
        case 'finalized':
          return 'Finalized'
        case 'auto_finalising':
          return 'Auto-finalizing'
        case 'locked_finalisation':
          return 'Locked'
        case 'lock_finalisation':
          return 'Lock Finalisation'
        case 'validating_recipients':
          return 'Validating Recipients'
        default:
          return 'Pending'
      }
    },
    instantFinalizeState() {
      switch (this.groupOrderDetails.state) {
        case 'pending':
          return false
        case 'locked':
          return false
        case 'finalized':
          return false
        case 'auto_finalising':
          return true
        case 'validating_recipients':
          return true
        case 'validating_subscription':
          return true
        case 'lock_finalisation':
          return false
        default:
          return false
      }
    },
    passwordTypeField() {
      return this.isEditingPassword ? 'text' : 'password'
    },
    backgroundImage() {
      return this.groupOrderDetails.customBackground
        ? this.groupOrderDetails.customBackground.url
        : defaultNotFoundImage
    },
    sizeChartImage() {
      return this.groupOrderDetails.groupOrderAttachment
        ? this.groupOrderDetails.groupOrderAttachment.filename
        : null
    },
    customTitleCharactersLeft() {
      if (this.customTitle) {
        return (
          this.customTitleMaxCharacters - this.customTitle.split(' ').length
        )
      } else {
        return this.customTitleMaxCharacters
      }
    },
    customDescriptionCharactersLeft() {
      if (this.customDescription) {
        return (
          this.customDescriptionMaxCharacters -
          this.customDescription.split(' ').length
        )
      } else {
        return this.customDescriptionMaxCharacters
      }
    },
    customSubtitleCharactersLeft() {
      if (this.customSubTitle) {
        return (
          this.customSubTitleMaxCharacters -
          this.customSubTitle.split(' ').length
        )
      } else {
        return this.customSubTitleMaxCharacters
      }
    }
  },
  watch: {
    orderAutoFinalizing() {
      if (this.orderAutoFinalizing === true && !this.instantFinalizeState) {
        this.$parent.startPolling()
      } else if (
        this.orderAutoFinalizing === true &&
        this.groupOrderDetails.state === 'validating_recipients'
      ) {
        this.$parent.startPolling()
      }
    },
    customTitle(newVal) {
      if (this.customTitleCharactersLeft > 0) {
        this.customTitle = newVal
      } else {
        this.customTitle = newVal
          .split(' ')
          .splice(0, this.customTitleMaxCharacters)
          .join(' ')
      }
    },
    customDescription(newVal) {
      if (this.customDescriptionCharactersLeft > 0) {
        this.customDescription = newVal
      } else {
        this.customDescription = newVal
          .split(' ')
          .splice(0, this.customDescriptionMaxCharacters)
          .join(' ')
      }
    },
    customSubTitle(newVal) {
      if (this.customSubtitleCharactersLeft > 0) {
        this.customSubTitle = newVal
      } else {
        this.customSubTitle = newVal
          .split(' ')
          .splice(0, this.customSubTitleMaxCharacters)
          .join(' ')
      }
    }
  },
  methods: {
    handleUpdateDomains(domains) {
      this.allowed_domains = domains
      this.updateGroupOrder('allowed-domains')
    },
    showFinalizeModal() {
      this.$store.dispatch(
        'modal/showRemoveModal',
        this.finalizeRedemptionModalName
      )
    },
    setEmailVerification() {
      this.isEmailVerified = !this.isEmailVerified
      this.updateGroupOrder('')
    },
    setShowPrice() {
      this.groupOrderDetails.showPrices = !this.groupOrderDetails.showPrices
      this.updateGroupOrder('')
    },
    handleCroppedData(data) {
      this.uploadBackground(data, 'group_order[custom_background]', false)
      this.image = null
    },

    handleUpload(event) {
      this.image = event
      this.isCropTool = true
    },

    uploadList(e) {
      const file = e.target.files[0]
      this.$store.dispatch('groupOrder/uploadAllowList', {
        type: 'file',
        id: this.groupOrderDetails.id,
        file: file
      })
    },
    updateData() {
      if (this.groupOrderDetails.enableCustomTitle) {
        this.redemptionTitle = 'custom-title'
      }
      if (this.groupOrderDetails.enableCustomSubheading) {
        this.redemptionSubTitle = 'custom-subtitle'
      }

      if (this.groupOrderDetails.enableCustomDescription) {
        this.redemptionDescription = 'custom-description'
      }
      if (this.groupOrderDetails['passwordProtected?']) {
        this.passwordValue = 'password'
      }
      if (this.groupOrderDetails.verifyEmails) {
        this.isEmailVerified = this.groupOrderDetails.verifyEmails
      }
      this.customTitle = this.groupOrderDetails.redemptionTitle || ''
      this.customSubTitle = this.groupOrderDetails.redemptionSubheading || ''
      this.customDescription =
        this.groupOrderDetails.redemptionDescription || ''

      this.password = this.groupOrderDetails.password
    },
    handleCustomChange(e, type) {
      if (this[type].length > 0) {
        this.updateGroupOrder(e)
      }
    },
    handleKeyUp: debounce(function(e) {
      this.updateGroupOrder(e, 'passsword')
    }, 1500),
    handleBlur(type) {
      // resets back to default if user leave custom title/description/password field empty
      switch (type) {
        case 'title':
          if (this.customTitle === '') {
            this.redemptionTitle = 'default-title'
            this.updateGroupOrder({}, 'defaultTitle')
          }
          break

        case 'sub-title':
          if (this.customTitle === '') {
            this.redemptionSubTitle = 'default-subtitle'
            this.updateGroupOrder({}, 'default-subtitle')
          }
          break
        case 'description':
          if (this.customDescription === '') {
            this.redemptionDescription = 'default-description'
            this.updateGroupOrder({}, 'defaultDescription')
          }
          break
        case 'password':
          if (this.password === '') {
            this.passwordValue = 'password'
          }
      }
    },

    validateEmail(value) {
      // eslint-disable-next-line no-useless-escape
      return /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/.test(
        value
      )
    },
    startPasswordEdition() {
      this.isEditingPassword = !this.isEditingPassword
      this.password = this.groupOrderDetails.password
        ? this.groupOrderDetails.password
        : ''
    },
    toggleGroupOrderStatus(toggleTo) {
      if (toggleTo === 'lock') {
        this.$store.dispatch(
          'groupOrder/lockGroupOrder',
          this.groupOrderDetails.id
        )
      } else if (toggleTo === 'unlock') {
        this.$store.dispatch(
          'groupOrder/unlockGroupOrder',
          this.groupOrderDetails.id
        )
      }
    },
    doCopy() {
      this.$copyText(this.groupOrderDetails.recipientCollectionPaigeUrl).then(
        () => {
          this.$store.dispatch('notification/pushNotification', {
            type: 'success',
            messages: [`Redemption page link copied`]
          })
        },
        error => {
          this.$store.dispatch('notification/pushNotification', {
            type: 'error',
            messages: [`Can not copy redemption page link.`]
          })
          console.log(error)
        }
      )
    },
    updateGroupOrder(e) {
      if (e === 'allowed-domains') {
        this.updatingDomain = true
      }
      this.$store
        .dispatch('groupOrder/updateGroupOrder', {
          password: this.password,
          passwordProtected: this.passwordValue === 'password' ? true : false,
          redemptionTitle: this.customTitle,
          redemptionSubTitle: this.customSubTitle,
          redemptionDescription: this.customDescription,
          customFields: this.groupOrderDetails.customFields,
          redirect: false,
          allowedDomains: this.allowed_domains,
          EmailVerified: this.isEmailVerified,
          showPrices: this.groupOrderDetails.showPrices,
          // setting values for whether redemption title should be true or false
          enableCustomTitle: this.redemptionTitle !== 'default-title',

          // setting values for whether redemption subtitle should be true or false
          enableCustomSubTitle: this.redemptionSubTitle !== 'default-subtitle',
          // setting values for whether redemption description should be true or false
          enableCustomDescription:
            this.redemptionDescription !== 'default-description'
        })
        .then(() => {
          if (e === 'allowed-domains') {
            this.updatingDomain = false
          }
        })

      // validation to know if the update is fired by the toggle for show/hide prices
      // this.$store
      //   .dispatch('groupOrder/updateGroupOrder', {
      //     password: this.password,
      //     customFields: this.groupOrderDetails.customFields,
      //     redirect: false,
      //     showPrices:
      //       e === 'toggle-prices'
      //         ? !this.groupOrderDetails.showPrices
      //         : this.groupOrderDetails.showPrices
      //   })
      //   .then(() => {
      //     if (e === 'allowed-domains') {
      //       this.updatingDomain = false
      //     }
      //   })
      // this.isEditingPassword = false

      // if (!this.password) {
      //   this.password = '**********'
      // }
    },
    showAutofinalizeModal() {
      if (
        this.groupOrderDetails.state !== 'auto_finalising' &&
        !this.groupOrderDetails.isAutofinalize
      ) {
        this.$store.dispatch('modal/showConfirmModal')
      } else if (this.groupOrderDetails.state === 'lock_finalisation') {
        this.$store.dispatch('modal/showConfirmModal')
      } else {
        this.$store.dispatch(
          'groupOrder/stopInstantFinalize',
          this.groupOrderDetails.id
        )
      }
    },

    cofirmAutoFinalize() {
      this.$store.dispatch(
        'groupOrder/startInstantFinalize',
        this.groupOrderDetails.id
      )
    },
    uploadBackground(e, type, isReplacingSizeChart) {
      let file = null

      if (type === 'group_order[custom_background]') {
        file = e
      } else {
        file = e.target.files[0]
      }

      const myNewFile = new File(
        [file],
        file.name.replace(/[^a-zA-Z0-9 ]/g, ''),
        {
          type: file.type
        }
      )
      if (file) {
        this.uploadLoading = true
        this.isReplacingSizeChart = isReplacingSizeChart

        bodyFormData.delete(type)
        bodyFormData.append(type, myNewFile)
        // if it is a size chart attachment we need to send the name field also
        if (type === 'group_order[group_order_attachment][file]') {
          bodyFormData.append(
            'group_order[group_order_attachment][name]',
            e.target.files[0].name
          )
        }
        this.team.teamCustomBackground.url = URL.createObjectURL(myNewFile)

        bodyFormData.delete('group_order[name]')
        bodyFormData.append('group_order[name]', this.groupOrderDetails.name)

        bodyFormData.delete('group_order[password_protected]')
        bodyFormData.append(
          'group_order[password_protected]',
          this.groupOrderDetails.password ? true : false
        )

        bodyFormData.delete('group_order[password]')
        bodyFormData.append(
          'group_order[password]',
          this.groupOrderDetails.password
        )

        bodyFormData.delete('allowed_domains')
        bodyFormData.append(
          'group_order[allowed_domains]',
          this.allowed_domains
        )
        bodyFormData.append('group_order[company_email_limited]', false)
        this.$store
          .dispatch('groupOrder/uploadGroupOrderCustomBackground', {
            storeData: bodyFormData,
            groupOrderId: this.groupOrderDetails.id
          })
          .then(() => {
            this.uploadLoading = false
            this.isReplacingSizeChart = false
          })
      }
    },

    openSizeChart() {
      const url = this.groupOrderDetails.groupOrderAttachment
        ? this.groupOrderDetails.groupOrderAttachment.url
        : null

      window.open(url, '_blank')
    },

    closeModal() {
      this.$store.commit('groupOrder/REMOVED_ALL_USERS_FROM_ALLOW_LIST', false)
    },
    handleCancel() {
      // this.$store.dispatch(
      //   'groupOrder/getGroupOrder',
      //   this.groupOrderDetails.id
      // )
      window.scrollTo(0, 0)
    },
    handleSaveChanges() {
      // this.updateGroupOrder('')
      this.$store.dispatch(
        'groupOrder/getGroupOrder',
        this.groupOrderDetails.id
      )
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';
.head-content-mobile {
  display: none;
}
.pill-holder {
  display: flex;

  span {
    display: flex;
    margin-left: 3px;
  }
}

h4.header {
  font-size: 2rem;
  font-family: $editorial;
  color: $pebble;
  font-weight: normal;
  text-align: left;
  line-height: 30px;
}

@media (max-width: 800px) {
  h4.header {
    line-height: 35px;
  }
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.custom-file-upload {
  font-size: 0.813rem;
  display: flex;
  align-items: center;
  gap: 3px;
  cursor: pointer;
  text-decoration: underline;
}

.group-order-details-wrapper {
  border-radius: 29px;
  padding: 0.2rem 0.8rem;
  background: inherit;
  border: 1px solid #000;

  .general-section {
    padding: 2rem 3rem;
  }
}

.head-content {
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: 150px 1fr;
  // margin-bottom: 1rem;

  p {
    text-align: left;
    font-weight: bold;
    font-size: 0.813rem;
    color: $main-6;
  }

  span {
    text-align: left;
    font-size: 0.813rem;
    color: $main-6;
  }

  .toggle-info {
    display: flex;
    align-items: center;
    gap: 1rem;

    span {
      font-size: 12px;
    }
  }
}

.domain-content {
  display: grid;
  grid-template-columns: 150px 1fr;
  margin-bottom: 2rem;
  grid-gap: 1rem;

  p {
    font-size: 0.813rem;
    margin-top: 0.8rem;
    text-align: left;
  }
}

.custom-section-holder {
  border-top: 1px solid #dfdad2;
  padding-top: 0.3rem;
}

.background-content-holder {
  padding: 0 3.2rem;
  .info-holder-sub-header {
    font-size: 0.838rem;
    margin-bottom: 1.2rem;
    color: #a09c95;
    font-weight: 600;
    text-align: left;
  }
}

.text-left {
  text-align: left;
}
.background-content {
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: 150px 1fr;
  margin-bottom: 2rem;

  &.login-methods {
    grid-template-columns: 1fr;
  }

  p {
    text-align: left;
    font-weight: bold;
    align-self: start;
    font-size: $content-font-size;

    &.allowed-files {
      color: rgba(36, 41, 44, 0.5);
      font-size: 10px;
      padding-top: 3px;
      margin-left: 1.25rem;
      font-weight: normal;
      align-self: center;
    }

    &.modified {
      display: flex;
      padding-top: 1.125rem;

      &.background {
        padding-top: 0;
      }

      span {
        display: block;
        margin-left: 5px;
        position: relative;
        bottom: 1px;
      }
    }
  }
  .caption__info {
    font-weight: 400;
    margin-bottom: 1rem;
  }

  .banner-portrait {
    background-color: #dfdad280;
    height: 100px;
    width: 180px;
    height: 160px;
    border: 1px solid #a09c95;
    border-radius: 12px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      margin: 0 auto;
    }
  }

  .file-name {
    cursor: pointer;
    color: #24292c;
    font-weight: bold;
    font-size: 0.813rem;
    margin-top: 0.75rem;
    padding-bottom: 0.5rem;
  }

  .banner-section {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: 1rem;
  }

  .file-holder {
    border: none;
    height: 88px;
    padding: 0.375rem 0;

    &.allow-list {
      height: auto;
      padding: 0.75rem 1rem;
    }

    &.none {
      border: none;
    }

    .divider {
      color: #25282a;
      margin: 1.25rem 0;
      font-size: 0.875rem;
      position: relative;
      width: 300px;
      height: 50px;
      line-height: 50px;
      text-align: center;

      &::before,
      &::after {
        position: absolute;
        width: 130px;
        height: 1px;
        top: 25px;
        background-color: #979797;
        content: '';
      }

      &::before {
        left: 0;
      }

      &::after {
        right: 0;
      }

      p {
        text-align: center;
      }
    }
  }
}

.login-methods {
  .caption {
    p {
      font-size: 0.875rem;
      text-align: left;
      margin-bottom: 1.25rem;
    }
  }
}

.password-content {
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: 170px 230px 1fr;
  margin-bottom: 2rem;

  p {
    text-align: left;
    font-weight: bold;
    align-self: center;
    font-size: $content-font-size;
  }

  .group-order-password {
    text-align: left;
    align-self: center;

    span {
      opacity: 0.8;
      font-family: $nunito;
      white-space: pre;
      font-size: $content-font-size;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  form {
    .form-group {
      margin-bottom: 0 !important;

      input {
        height: 50px !important;
        border: 1px solid $onyx !important;
        padding: 0rem 1rem !important;
      }
    }
  }
}

.region-holder {
  // margin-bottom: 2rem;
  .title {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    margin-bottom: 1.2rem;
    p {
      font-size: 0.838rem;
    }
    small {
      text-align: left;
      color: #514d43;
      font-size: 11px;
      font-family: $inter;
    }
  }
}

.special-instruction {
  .input-label {
    display: flex;
    gap: 10px;
  }

  padding-top: 20px;
  padding-bottom: 20px;
}

small.lock-status {
  font-size: 0.613rem;
  color: #514d43;
  position: relative;
  left: -8px;
}

.customizables {
  display: grid;
  grid-template-columns: 70px 1fr;
  margin-bottom: 1.125rem;
  gap: 1rem;

  /* .radio-holder { */
  /* width: 20%; */
  /* display: flex;
    align-items: center; */
  /* } */

  textarea {
    background: inherit;
    font-family: $nunito;
    padding: 2px 0;
    width: 65%;
    max-width: 70%;
    resize: none;
    border: none;
    border-bottom: 1px solid #24292c;
    font-size: 0.875rem;

    &.custom {
      resize: auto;
    }

    &:focus {
      outline: none;
    }
  }
  .characters-info {
    position: relative;
    top: -12px;
    color: rgba(35, 34, 32, 0.5);
    font-size: 0.625rem;
    width: 65%;
    max-width: 70%;
    text-align: right;
  }

  .password-holder {
    width: 40%;
    position: relative;

    input {
      height: 1.75rem;
      padding: 2px 0;
      font-size: 0.875rem;
      background: inherit;
      font-family: $nunito;
      border: none;
      border-bottom: 1px solid #24292c;
    }

    span {
      position: absolute;
      top: 9px;
      right: 0;
      font-size: 0.625rem;
      color: #676767;
      cursor: pointer;
    }
  }

  ::placeholder {
    color: #9b9b9b;
    font-size: 0.75rem;
  }

  p {
    text-align: left;
    font-weight: bold;
    align-self: center;
    font-size: $content-font-size;
  }

  div.caption {
    width: 95%;

    p {
      font-weight: 400;
      line-height: 23px;

      &:nth-child(2) {
        margin-top: 1.25rem;
      }

      &:nth-child(3) {
        margin: 0.5rem 0;
      }
    }
  }
}

.projects-footer-actions {
  margin: 1.5rem auto;
  .button-gemnote--small {
    text-transform: uppercase;
    padding: 0px 2rem !important;
    font-weight: 500;
    width: auto;
    border-color: #232220;
    height: 3rem;

    &.custom-button {
      background: inherit;
      color: #232220;
      text-transform: uppercase;
      &.disabled {
        cursor: not-allowed;
      }
    }
    &.isDisabled {
      opacity: 0.8;
      cursor: not-allowed;
    }
  }
  .whitebutton-gemnote--small {
    text-transform: uppercase;
    padding: 0px 2rem !important;
    width: auto;
    border-color: #232220;
    background-color: #232220;
    color: #fff;

    &.custom-button {
      background: inherit;
      text-transform: uppercase;
      &.disabled {
        cursor: not-allowed;
      }
    }
    &.isDisabled {
      opacity: 0.8;
      cursor: not-allowed;
    }
  }
}

.page-link-content {
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: 170px 1fr;

  p {
    text-align: left;
    font-weight: 600;
    align-self: center;
    font-size: $content-font-size;
  }

  .link-content {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;

    .copy-holder {
      border-left: 1px solid $onyx;
    }

    span {
      min-width: 50px;
      text-align: justify;
      padding: 1rem;
      word-break: break-all;
      font-size: $content-font-size;
      width: 100%;
      color: $main-6;
    }

    small {
      padding-top: 8px;
      font-size: 0.563rem;
      text-align: left;
      color: rgba(36, 41, 44, 0.5);
    }

    div {
      min-width: 50px;
      display: flex;
      justify-content: center;

      &.primary {
        border: 1px solid $onyx;
      }

      img {
        cursor: pointer;
        width: 1.2rem;
      }
    }
  }
}

.confirm-text {
  white-space: pre-line;
  text-align: left;
  font-weight: normal;
  font-family: $inter;
  color: $pebble;
}

.success-button-holder {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1.5rem;

  button.success {
    border: 1px solid $main-white;
    color: $main-white;
    height: 36px;
    border-radius: 40px;
    font-size: 0.875rem;
    font-weight: bold;
    padding: 0px 28px;
  }
}

.special-instruction-holder {
  width: 60%;
  padding-top: 0px;
  textarea {
    margin-bottom: 0.5rem;
    background: inherit;
    font-family: $nunito;
    padding: 10px;
    width: 100%;
    display: block;
    /* margin-left: 0; */
    resize: none;
    border: none;
    border: 1px solid #9b9b9b;
    font-size: 0.875rem;
    min-height: 160px;

    &.custom {
      resize: auto;
    }

    &:focus {
      outline: none;
    }

    &.error {
      border-bottom: 1px solid #da5737;
    }
    &::placeholder {
      font-size: 0.815rem;
      color: #a09c95;
    }
  }
  .characters-info {
    position: relative;
    top: -10px;
    color: rgba(35, 34, 32, 0.5);
    font-size: 0.625rem;
    width: 100%;
    max-width: 100%;
    text-align: right;
    display: block;
    padding-top: 0.2rem;
  }
}

.toggle-disabled {
  .toggle-slider {
    cursor: not-allowed !important;
  }
}

@media (max-width: 630px) {
  .group-order-details {
    padding-bottom: 10rem !important;
  }
}
@media (max-width: 860px) {
  .background-content-holder {
    padding: 1.2rem;
    &.margin-top-2,
    &.margin-top-1 {
      margin-top: 0;
    }
  }
  .general-section {
    display: none;
  }
  .head-content {
    display: none !important;
    flex-wrap: wrap;
  }
  .head-content-mobile {
    display: grid;
    justify-content: left;
    padding: 1rem;
    p {
      text-align: left;
      font-weight: bold;
      font-size: 0.813rem;
      color: $main-6;
    }

    span {
      text-align: left;
      font-size: 0.813rem;
      color: $main-6;
    }
  }
  .head-content-mobile-container {
    display: grid;
    margin-bottom: 20px;
    grid-template-columns: 1fr 1fr;

    .toggle-info {
      width: max-content;
    }
    div {
      .toggle-info {
        width: max-content;
      }
    }
  }
  .group-order-details-wrapper {
    padding: 0.2rem 0.5rem;
  }
  .background-content {
    display: block;
    div {
      margin-bottom: 12px;
    }
    p {
      margin-bottom: 12px;
    }
  }
  .customizables textarea {
    width: 100% !important;
    max-width: 100%;
    margin-top: 12px;
  }
  .customizables {
    display: block;
  }
  .caption {
    padding: 12px;
  }
  .customizables .password-holder {
    width: 100%;
  }
  .domain-content {
    display: block;
  }
  .page-link-content {
    display: block;
    p {
      margin-bottom: 12px !important;
    }
  }
  .copy-holder p {
    padding-top: 12px;
    background: red !important;
    width: 150px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
